var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-btn',{staticClass:"card-shadow rounded-2",attrs:{"color":_vm.color,"dark":_vm.dark && !_vm.disabled,"fab":!_vm.noFab,"x-small":!_vm.large,"disabled":_vm.disabled},on:{"click":function($event){return _vm.$emit('onClick')}}},[_c('v-icon',[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }